import merge from "lodash/merge";

class Histogram{
    chartConf:any = {
        api:'',
        col:6,
        ele:''
    }
    constructor(options: any) {
    this.chartConf = merge(this.chartConf, options);
    }

    // 初始化图表 柱状图
    init(){
        let self = this
        self.showChart()
        if(self.chartConf.refresh_time > 0){
          // 有定时刷新
          self.refresh()
        }
    }

    async showChart(){
        let self = this
        let res = await self.getDataAjax(self.chartConf.api)
        let data = self.chartConf.data(res)
        self.makeChart(data)

    }

    makeChart(data:any){
        let self = this
        let _container = $(`#${self.chartConf.ele}`)
        let max_num = Math.abs(data[0].f62) - Math.abs(data[data.length-1].f62) > 0 ? Math.abs(data[0].f62) : Math.abs(data[data.length-1].f62)
        _container.css("display","flex")
        let col = ''
        data.forEach((item:any,index:number) => {
            col += `<div style='width:0px;flex:1;height:10rem;display:flex;flex-direction:column-reverse;margin-left:1rem;margin-right:${index == self.chartConf.col-1 ? '1rem':0}'>
                            <div style="flex:.15;text-align: center;font-size:1rem;white-space: nowrap;text-overflow: ellipsis;overflow:hidden;color:#666666;">${item.f14}</div>
                            <div style="flex:${(Math.abs(item.f62)/max_num)*0.7};background-color:${item.f62>0?'#f54e4e':'#33b333'};border-bottom:1px solid ${item.f62>0?'#f54e4e':'#33b333'}"></div>
                            <div style="text-align: center;font-size:1rem;">${(item.f62/100000000).toFixed(3)}</div>
                        </div>` 
        })
        
        _container.html(col)
    }

    // 请求数据
    async getDataAjax(url: any) {
        // Ajax数据请求
        let self = this
        // let rnd = 'callbackdata' + Math.floor(Math.random() * 10000000 + 1);
        let backdata = new Promise(function (res, rej) {
          try {
            $.ajax({
              url: url +"?cb=?",
              type: 'GET',
              timeout: 15000,
              dataType: 'jsonp',
              success: function (data) {
                // 返回成功数据
                if (data && data.rc == "0") {
                    res(data)
                } else {
                    rej([]);
                }
              },
              error: function (err) {
                rej([])
              }
            });
          } catch (error) {
            // 错误处理
          }
        })
        
        return backdata.then(function (v: any) {
          return v
        }).catch(function (ErrMsg: any) {
          return []
        });
    
      }

    // 数据刷新
    refresh(){
      let self = this
      setInterval(function(){
        self.showChart()
      },self.chartConf.refresh_time * 1000)
    }
}

export default Histogram